export function isDesktop(): boolean {
  return (document.documentElement.clientWidth || 0) >= 834;
}
